import fixtures from './fixtures.json';
import Injectable from '@/modules/shared/domain/dependency_injection/injectable';
import { ResidenceRepository } from '../../../domain/repository/residence-repository';

@Injectable()
export default class ResidenceDummyRepository implements ResidenceRepository {
  findAll() {
    return Promise.resolve(fixtures);
  }
}
